export default "__VITE_ASSET__COGlQfDH__"